(function () {
  const formatNumber = (number) => String(number).padStart(2, '0');
  const updateTimer = (timer, selector, value) => timer.querySelector(selector).innerText = formatNumber(value);

  // The end date is a merchant text setting, so a translated storefront can
  // carry it in Arabic ("٣١ يوليو ٢٠٢٤"), which Date cannot parse.
  const ARABIC_MONTHS = {
    'يناير': 0, 'فبراير': 1, 'مارس': 2, 'ابريل': 3, 'مايو': 4, 'يونيو': 5, 'يونيه': 5,
    'يوليو': 6, 'يوليه': 6, 'اغسطس': 7, 'سبتمبر': 8, 'اكتوبر': 9, 'نوفمبر': 10, 'ديسمبر': 11,
    'كانون الثاني': 0, 'شباط': 1, 'اذار': 2, 'نيسان': 3, 'ايار': 4, 'حزيران': 5,
    'تموز': 6, 'اب': 7, 'ايلول': 8, 'تشرين الاول': 9, 'تشرين الثاني': 10, 'كانون الاول': 11,
  };

  const normalizeArabic = (str) =>
    String(str)
      .replace(/[٠-٩]/g, (digit) => String(digit.charCodeAt(0) - 0x0660))
      .replace(/[۰-۹]/g, (digit) => String(digit.charCodeAt(0) - 0x06f0))
      .replace(/[ً-ْـ]/g, '')
      .replace(/[أإآ]/g, 'ا')
      .replace(/،/g, ',')
      .replace(/\s+/g, ' ')
      .trim();

  const parseArabicDate = (str) => {
    const text = normalizeArabic(str);
    const dayFirst = text.match(/^(\d{1,2}) ([ء-ي ]+?),? (\d{4})(?: (\d{1,2}):(\d{2}))?$/);
    const monthFirst = text.match(/^([ء-ي ]+?) (\d{1,2}),? (\d{4})(?: (\d{1,2}):(\d{2}))?$/);
    if (!dayFirst && !monthFirst) return NaN;

    const day = dayFirst ? dayFirst[1] : monthFirst[2];
    const monthName = dayFirst ? dayFirst[2] : monthFirst[1];
    const rest = dayFirst ? dayFirst.slice(3) : monthFirst.slice(3);
    const month = ARABIC_MONTHS[monthName.trim()];
    if (month === undefined) return NaN;

    return new Date(
      parseInt(rest[0], 10),
      month,
      parseInt(day, 10),
      rest[1] ? parseInt(rest[1], 10) : 0,
      rest[2] ? parseInt(rest[2], 10) : 0,
      0
    ).getTime();
  };

  const initTimer = () => {
    const currentTime = new Date().getTime();
    const countDownTimers = document.querySelectorAll(".countdown-bar-js");

    countDownTimers.forEach((timer) => {
      let { date: endDateStr, complited: completedCountdown } = timer.dataset;
      let endTime = new Date(endDateStr).getTime();
      if (Number.isNaN(endTime)) endTime = parseArabicDate(endDateStr);
      let timeLeft = Math.max(endTime - currentTime, 0);

      if (timeLeft === 0 && completedCountdown === "hide_countdown") {
        timer.remove();
      } else if (timeLeft === 0 && completedCountdown === "cycle") {
        endTime = currentTime + 2.33 * 24 * 60 * 60 * 1000;
        timer.dataset.date = new Date(endTime).toISOString();
        timeLeft = Math.max(endTime - currentTime, 0);
      }

      const [days, hours, minutes, seconds] = [
        Math.floor(timeLeft / (1000 * 60 * 60 * 24)),
        Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60)),
        Math.floor((timeLeft % (1000 * 60)) / 1000)
      ];

      updateTimer(timer, ".countdown-bar__days .countdown-bar__number", days);
      updateTimer(timer, ".countdown-bar__hours .countdown-bar__number", hours);
      updateTimer(timer, ".countdown-bar__min .countdown-bar__number", minutes);
      updateTimer(timer, ".countdown-bar__sec .countdown-bar__number", seconds);
    });
  };

  let initTimerInterval;

  const startInterval = () => {
    if (!document.hidden) {
      initTimer();
      initTimerInterval = setInterval(initTimer, 1000);
    }
  };

  document.addEventListener("shopify:section:load", startInterval);
  startInterval();
})();